declare namespace $ {

	type $mol_view__sub_shm_projects_tests_1 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_search__query_shm_projects_tests_2 = $mol_type_enforce<
		ReturnType< $shm_projects_tests['filter'] >
		,
		ReturnType< $mol_search['query'] >
	>
	type $mol_view__sub_shm_projects_tests_3 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_projects_tests_4 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_projects_tests_5 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_projects_tests_6 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_projects_tests_7 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_list__rows_shm_projects_tests_8 = $mol_type_enforce<
		ReturnType< $shm_projects_tests['test_rows'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_view__sub_shm_projects_tests_9 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_projects_tests_10 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_projects_tests_11 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_projects_tests_12 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_projects_tests_13 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_projects_tests_14 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_projects_tests_15 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_link__uri_shm_projects_tests_16 = $mol_type_enforce<
		ReturnType< $shm_projects_tests['test_uri'] >
		,
		ReturnType< $mol_link['uri'] >
	>
	type $mol_link__title_shm_projects_tests_17 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__external_shm_projects_tests_18 = $mol_type_enforce<
		boolean
		,
		ReturnType< $mol_link['external'] >
	>
	type $mol_view__sub_shm_projects_tests_19 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_projects_tests_20 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $shm_projects_tests extends $mol_view {
		summary( ): string
		Summary( ): $mol_view
		filter( next?: string ): string
		Filter( ): $mol_search
		Head_status( ): $mol_view
		Head_title( ): $mol_view
		Head_started( ): $mol_view
		Head_duration( ): $mol_view
		Head_open( ): $mol_view
		Table_head( ): $mol_view
		test_rows( ): readonly(any)[]
		Rows( ): $mol_list
		Table( ): $mol_view
		test_status( id: any): string
		Test_status( id: any): $mol_view
		test_title( id: any): string
		Test_title( id: any): $mol_view
		test_source( id: any): string
		Test_source( id: any): $mol_view
		Test_info( id: any): $mol_view
		test_started( id: any): string
		Test_started( id: any): $mol_view
		test_duration( id: any): string
		Test_duration( id: any): $mol_view
		test_uri( id: any): string
		Test_open( id: any): $mol_link
		project_id( ): string
		sub( ): readonly(any)[]
		Test( id: any): $mol_view
		Empty( ): $mol_view
	}
	
}

//# sourceMappingURL=tests.view.tree.d.ts.map